export const SET_TICKET_MESSAGES = "SET_TICKET_MESSAGES";
export const UPDATE_TICKET_MESSAGES = "UPDATE_TICKET_MESSAGES";
export const UPDATE_TICKET_MESSAGE = "UPDATE_TICKET_MESSAGE";
export const DELETE_TICKET_MESSAGE = "DELETE_TICKET_MESSAGE";
export const CLEAR_TICKET_MESSAGES = "CLEAR_TICKET_MESSAGES";
export const SET_ACTIVE_TICKET = "SET_ACTIVE_TICKET";
export const SET_AGENT_TYPING_TICKET = "SET_AGENT_TYPING_TICKET";
export const CLEAR_THIRD_USER_MESSAGE = "CLEAR_THIRD_USER_MESSAGE";
export const CLEAR_THIRD_USER_FIRST_MESSAGE = "CLEAR_THIRD_USER_FIRST_MESSAGE";
